/** Detect cancelled / cancellation-style booking status (e.g. "cancelled by guest", "canceled"). */
export function isCancelledBookingStatus(status: unknown): boolean {
  const s = String(status ?? '').trim().toLowerCase();
  return s.includes('cancel');
}
